export default __webpack_public_path__ + "static/media/3178.08fe5bdc.png";